import { render } from "./DeletionModal.vue?vue&type=template&id=90613150"
import script from "./DeletionModal.vue?vue&type=script&lang=js"
export * from "./DeletionModal.vue?vue&type=script&lang=js"

import "./DeletionModal.vue?vue&type=style&index=0&id=90613150&lang=css"

import exportComponent from "/var/www/gigs.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__